import { IRequestOptions, IResponseResult } from 'models/api.model'
import {
  AUTOMATION_API_START_WOOFY_CHAT_URL_MAP,
  AUTOMATION_API_START_WOOFY_CHAT_URL_MAP_V2,
  TWoofyChatApiVersion,
} from 'nove8/constants/root-constants'
import { RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export class AutomationApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  startWoofyChat(payload: {
    sessionId: string
    leadId: string
    apiVersion: TWoofyChatApiVersion
  }): Promise<IResponseResult<unknown>> {
    const startUrls =
      payload.apiVersion === 'v2'
        ? AUTOMATION_API_START_WOOFY_CHAT_URL_MAP_V2
        : AUTOMATION_API_START_WOOFY_CHAT_URL_MAP

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      credentials: 'omit',
      body: {
        sessionId: payload.sessionId,
        leadId: payload.leadId,
      },
    }

    return this.api.makeCustomRequest<unknown>(
      startUrls[import.meta.env.CURRENT_ENV],
      options,
    )
  }

  storeWoofyCreative(payload: {
    creativeId: string
    leadId: string
    apiVersion: TWoofyChatApiVersion
  }): Promise<IResponseResult<unknown>> {
    const url =
      payload.apiVersion === 'v2'
        ? 'automation.nove8.com/webhook/woofy/v2/chat/store-creative'
        : 'automation.nove8.com/webhook/woofy/chat/store-creative'

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      credentials: 'omit',
      body: {
        creativeId: payload.creativeId,
        leadId: payload.leadId,
      },
    }

    return this.api.makeCustomRequest<unknown>(url, options)
  }

  storeWoofyQuiz(payload: {
    quiz: { question: string; answers: string[] }[]
    leadId: string
    apiVersion: TWoofyChatApiVersion
  }): Promise<IResponseResult<unknown>> {
    const url =
      payload.apiVersion === 'v2'
        ? 'automation.nove8.com/webhook/woofy/v2/chat/store-quiz'
        : 'automation.nove8.com/webhook/woofy/chat/store-quiz'

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      credentials: 'omit',
      body: {
        quiz: payload.quiz,
        leadId: payload.leadId,
      },
    }

    return this.api.makeCustomRequest<unknown>(url, options)
  }

  getWoofyChatProfile(payload: {
    leadId: string
  }): Promise<IResponseResult<unknown>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      credentials: 'omit',
      params: {
        leadId: payload.leadId,
      },
    }

    return this.api.makeCustomRequest<unknown>(
      'automation.nove8.com/webhook/woofy/v2/chat/profile',
      options,
    )
  }

  getWoofyCreative(payload: {
    creativeId: string
    apiVersion: TWoofyChatApiVersion
  }): Promise<IResponseResult<unknown>> {
    const baseUrl =
      payload.apiVersion === 'v2'
        ? 'automation.nove8.com/webhook/a1e25d9f-ed01-453b-a47b-3bc418b357ec/woofy/v2/chat/creative'
        : 'automation.nove8.com/webhook/36ed41e7-e231-4467-a805-4fe2388e09e7/woofy/chat/creative'

    const options: IRequestOptions = {
      method: RequestMethod.GET,
      credentials: 'omit',
    }

    return this.api.makeCustomRequest<unknown>(
      `${baseUrl}/${payload.creativeId}`,
      options,
    )
  }
}
